import React, { useState } from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import Heading from '~/components/core/TextComponents/Heading';

import type { ReportParameters } from '../shared/ReportParameterFields';

import { useGeneratedReports } from './hooks/useGeneratedReports';
import GeneratedReportsFilters from './GeneratedReportsFilters';
import GeneratedReportsTable from './GeneratedReportsTable';
import GenerateReportDialog, { type FormatKey } from './GenerateReportDialog';
import { GENERATED_REPORTS_TEXTS } from './texts';

const AllReportsTab: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const {
    reports,
    total,
    isLoading,
    isError,
    filterParams,
    handleSearch,
    handleSortChange,
    clearFilters,
    deleteReport,
    downloadReport,
    generateReport,
    setPage,
    setLimit,
    reloadReports,
  } = useGeneratedReports();

  const handleGenerateSubmit = async (values: {
    name: string;
    report_template_id: number;
    parameters?: ReportParameters | null;
    snapshot_date?: string | null;
    export_format: FormatKey;
  }): Promise<boolean> => {
    const result = await generateReport({
      name: values.name,
      report_template_id: values.report_template_id,
      parameters: values.parameters,
      snapshot_date: values.snapshot_date,
      export_format: values.export_format,
    });
    return result !== null;
  };

  return (
    <div className="p-16">
      <div className="mb-16 flex items-center justify-between">
        <Heading variant={Heading.TYPES.H3}>{GENERATED_REPORTS_TEXTS.PAGE_TITLE}</Heading>
        <Button variant="contained" color="primary" onClick={() => setIsDialogOpen(true)}>
          {GENERATED_REPORTS_TEXTS.GENERATE_BUTTON}
        </Button>
      </div>

      <GeneratedReportsFilters handleSearch={handleSearch} clearFilters={clearFilters} isLoading={isLoading} />

      <GeneratedReportsTable
        reports={reports}
        total={total}
        loading={isLoading}
        isError={isError}
        filterParams={filterParams}
        onPageChange={setPage}
        onLimitChange={setLimit}
        onDownload={downloadReport}
        onDelete={deleteReport}
        onSortByColumn={handleSortChange}
        sortBy={filterParams.sortBy}
        orderBy={filterParams.orderBy}
        onRefresh={reloadReports}
      />

      {isDialogOpen ? (
        <GenerateReportDialog onClose={() => setIsDialogOpen(false)} onSubmit={handleGenerateSubmit} />
      ) : null}
    </div>
  );
};

export default AllReportsTab;
